import { useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";
import { StatusPill } from "@/components/kit";
import ImageZoom from "@/components/ImageZoom";

const money = (c) => `$${((c || 0) / 100).toLocaleString(undefined, { minimumFractionDigits: 2 })}`;
const STATUS_LABEL = {
  done: "Done", needs_souvenir: "Needs souvenir made", redone: "Redone after error",
  duplicate: "Duplicate", info_required: "Info still required",
};
const statusTone = (code) => (code === "done" ? "olive" : code === "duplicate" ? "gray" : "gold");

// Legacy Bricks owned by a member/visitor (Batch 5 Job 2). Member-safe view:
// inscription, status, amount paid, photo — NO internal production cost.
// Silently renders nothing if the viewer lacks Legacy Bricks access (403) or has no bricks.
export default function PersonBricks({ kind, id }) {
  const [bricks, setBricks] = useState(null);

  const load = useCallback(async () => {
    try { const r = await api.get("/bricks/by-person", { params: { kind, id } }); setBricks(r.data.bricks || []); }
    catch { setBricks([]); }
  }, [kind, id]);
  useEffect(() => { load(); }, [load]);

  if (!bricks || bricks.length === 0) return null;

  return (
    <div className="bg-cream border border-ink/15 rounded-xl p-5" data-testid="person-bricks">
      <h3 className="font-zilla text-lg font-semibold mb-3">Legacy Bricks</h3>
      <div className="space-y-2">
        {bricks.map((b, i) => (
          <div key={`${b.order_id}-${i}`} data-testid="person-brick-row"
            className="flex items-center gap-3 bg-warm-cream/50 border border-ink/10 rounded-lg p-3">
            {b.photo_url
              ? <ImageZoom src={b.photo_url} alt="Brick" className="w-14 h-14 rounded-md object-cover shrink-0" />
              : <div className="w-14 h-14 rounded-md bg-ink/5 shrink-0" />}
            <div className="min-w-0 flex-1">
              <div className="font-semibold text-[15px] whitespace-pre-line break-words">{b.inscription || <span className="text-ink/45">No inscription</span>}</div>
              <div className="text-[12px] text-ink/55 mt-0.5">Type {b.type} · Paid {money(b.amount_paid_cents)}</div>
            </div>
            <StatusPill tone={statusTone(b.status)}>{STATUS_LABEL[b.status] || b.status}</StatusPill>
          </div>
        ))}
      </div>
    </div>
  );
}
